var _circle, _circle2, _path, _ellipse, _path2, _circle3, _circle4, _path3, _circle5, _g, _g2, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoloGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.999,
    y1: 7.605,
    x2: 99.999,
    y2: 197.0741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    style: {
      stopColor: "#AFAFAF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3249,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4403,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5159,
    style: {
      stopColor: "#D4D4D3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6364,
    style: {
      stopColor: "#EBEAEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6718,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7078,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7584,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    style: {
      stopColor: "#989898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9315,
    style: {
      stopColor: "#40403F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#212121"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_1_)",
    cx: 99.999,
    cy: 102.085,
    r: 94.479
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9985,
    y1: 10.8345,
    x2: 99.9985,
    y2: 193.8262
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.096,
    style: {
      stopColor: "#C3C2C1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1641,
    style: {
      stopColor: "#A9A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2037,
    style: {
      stopColor: "#B7B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2815,
    style: {
      stopColor: "#DDDDDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3167,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3779,
    style: {
      stopColor: "#CFCECD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#BAB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4588,
    style: {
      stopColor: "#B3B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4985,
    style: {
      stopColor: "#BAB9B9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5618,
    style: {
      stopColor: "#CFCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6405,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6409,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6818,
    style: {
      stopColor: "#CDCCCC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7009,
    style: {
      stopColor: "#BEBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7382,
    style: {
      stopColor: "#9A9A9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7397,
    style: {
      stopColor: "#989898"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    style: {
      stopColor: "#959595"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.778,
    style: {
      stopColor: "#8D8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    style: {
      stopColor: "#7F7E7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8139,
    style: {
      stopColor: "#6C6B6B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8316,
    style: {
      stopColor: "#565554"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8491,
    style: {
      stopColor: "#3C3C3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8662,
    style: {
      stopColor: "#1F1F1F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8666,
    style: {
      stopColor: "#1E1E1E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8787,
    style: {
      stopColor: "#2A2A2A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9212,
    style: {
      stopColor: "#4D4C4C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9571,
    style: {
      stopColor: "#686868"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9844,
    style: {
      stopColor: "#7A7A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#818181"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_2_)",
    cx: 99.999,
    cy: 102.085,
    r: 91.249
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.999,
    y1: 10.4404,
    x2: 99.999,
    y2: 193.728
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#231F20"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M99.999,193.728c-12.371,0-24.373-2.424-35.672-7.201c-10.912-4.615-20.713-11.224-29.129-19.641 c-8.417-8.416-15.025-18.216-19.641-29.131c-4.779-11.297-7.201-23.299-7.201-35.67c0-12.373,2.422-24.374,7.201-35.673 C20.173,55.5,26.781,45.698,35.198,37.283c8.416-8.417,18.217-15.024,29.129-19.64c11.299-4.779,23.301-7.202,35.672-7.202 c12.372,0,24.373,2.423,35.672,7.202c10.913,4.616,20.713,11.224,29.13,19.64c8.416,8.416,15.024,18.217,19.64,29.129 c4.779,11.299,7.202,23.3,7.202,35.673c0,12.371-2.423,24.373-7.202,35.67c-4.615,10.915-11.224,20.715-19.64,29.131 c-8.417,8.417-18.217,15.025-29.13,19.641C124.372,191.304,112.371,193.728,99.999,193.728z M99.999,11.229 c-50.098,0-90.855,40.758-90.855,90.856c0,50.097,40.757,90.854,90.855,90.854c50.098,0,90.855-40.758,90.855-90.854 C190.854,51.986,150.097,11.229,99.999,11.229z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9985,
    y1: 26.1436,
    x2: 99.9985,
    y2: 178.436
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E5"
    }
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "url(#SVGID_4_)",
    cx: 99.999,
    cy: 102.085,
    rx: 77.04,
    ry: 75.94
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.999,178.419c-10.453,0-20.593-2.018-30.139-5.998c-9.221-3.846-17.501-9.348-24.613-16.358 c-7.112-7.01-12.696-15.174-16.596-24.264c-4.039-9.412-6.086-19.409-6.086-29.714c0-10.307,2.047-20.304,6.086-29.715 c3.9-9.091,9.484-17.254,16.596-24.264c7.111-7.01,15.392-12.514,24.613-16.358c9.546-3.98,19.686-5.998,30.139-5.998 c10.452,0,20.593,2.018,30.139,5.998c9.221,3.844,17.502,9.348,24.613,16.358c7.112,7.01,12.695,15.173,16.596,24.264 c4.039,9.411,6.087,19.409,6.087,29.715c0,10.305-2.048,20.302-6.087,29.714c-3.9,9.09-9.483,17.254-16.596,24.264 c-7.111,7.011-15.393,12.513-24.613,16.358C120.592,176.401,110.451,178.419,99.999,178.419z M99.999,26.538 c-42.262,0-76.646,33.89-76.646,75.547c0,41.655,34.384,75.546,76.646,75.546c42.263,0,76.646-33.891,76.646-75.546 C176.646,60.428,142.262,26.538,99.999,26.538z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 99.998,
    cy: 102.084,
    r: 72.0137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    style: {
      stopColor: "#6D6D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6556,
    style: {
      stopColor: "#464645"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_5_)",
    cx: 99.998,
    cy: 102.085,
    r: 72.013
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_6_",
    cx: 99.998,
    cy: 102.084,
    r: 72.0137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1142,
    style: {
      stopColor: "#777777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2716,
    style: {
      stopColor: "#6D6D6D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4541,
    style: {
      stopColor: "#5C5C5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6556,
    style: {
      stopColor: "#464645"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8699,
    style: {
      stopColor: "#2B2B2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#161616"
    }
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_6_)",
    cx: 99.998,
    cy: 102.085,
    r: 72.013
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0063,
    y1: 7.6206,
    x2: 100.0063,
    y2: 91.8057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "url(#SVGID_7_)",
    d: "M166.076,34.568c-17.034-16.671-40.352-26.948-66.069-26.948 c-25.718,0-49.035,10.277-66.071,26.948c-3.885,5.563-6.041,11.71-6.041,18.173c0,25.014,32.286,39.064,72.111,39.064 c39.825,0,72.11-14.051,72.11-39.064C172.117,46.278,169.961,40.131,166.076,34.568z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.0068,
    y1: 7.6206,
    x2: 100.0068,
    y2: 223.4619
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5833,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6491,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6967,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7386,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7772,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    style: {
      stopColor: "#B0B0B0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8482,
    style: {
      stopColor: "#8C8C8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8815,
    style: {
      stopColor: "#626262"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9129,
    style: {
      stopColor: "#323232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9411,
    style: {
      stopColor: "#010101"
    }
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    display: "none",
    fill: "url(#SVGID_8_)",
    cx: 100.007,
    cy: 102.093,
    r: 94.471
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M164.926,90.88c3.919,22.367,11.426,29.979,1.087,48.332c-4.591,8.15-11.326,5.339-17.053,6.438 c-11.006,2.116-23.019,2.05-42.111,5.396c-24.388,4.272-43.491,12.69-60.381,11.397c-4.097-0.314-8.917,3.851-11.898,4.873 c-1.375,0.472-2.737,0.189-2.071,0.875c-12.917-13.17-22.12-30.252-25.545-49.796C-2.051,67.002,32.311,18.042,83.704,9.039 c26.973-4.726,53.276,2.495,73.484,17.853c0.327,0.25-0.989,0.615-0.935,1.012C158.14,41.679,160.725,66.9,164.926,90.88z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 1.873508e-006 2.858054e-006)",
    clipPath: "url(#SVGID_10_)"
  }, /*#__PURE__*/React.createElement("image", {
    overflow: "visible",
    width: 1188,
    height: 1075,
    xlinkHref: "182C286E.png",
    transform: "matrix(0.24 0 0 0.24 -108.5884 -71.9253)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M146.934,143.396c-11.458,13.008-28.238,21.215-46.935,21.215c-18.697,0-35.476-8.207-46.934-21.215 c2.434-15.12,11.996-27.855,25.132-34.646c1.085,1.03,2.241,1.979,3.459,2.846c5.383,3.817,11.726,5.835,18.343,5.835 c6.615,0,12.959-2.018,18.342-5.835c1.22-0.866,2.376-1.817,3.461-2.846C134.937,115.54,144.5,128.275,146.934,143.396z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M124.361,85.702c0,8.21-4.06,15.47-10.282,19.884c-3.976,2.821-8.834,4.479-14.08,4.479 s-10.104-1.657-14.08-4.479c-6.224-4.414-10.284-11.674-10.284-19.884c0-13.456,10.908-24.364,24.364-24.364 S124.361,72.246,124.361,85.702z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "#231F20",
    d: "M116.852,32.028c12.408,12.942,20.034,30.504,20.034,49.85 c0,39.786-32.255,72.04-72.041,72.04c-5.803,0-11.445-0.686-16.851-1.981c13.113,13.675,31.564,22.188,52.005,22.188 c39.786,0,72.04-32.254,72.04-72.039C172.039,68.101,148.509,39.614,116.852,32.028z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_11_",
    cx: 99.999,
    cy: 102.083,
    r: 72.0407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E6E6E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#333333"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "url(#SVGID_11_)",
    d: "M136.886,81.877c0-19.345-7.626-36.907-20.034-49.85 c-4.651-1.114-9.479-1.779-14.432-1.942c-0.804-0.03-1.611-0.042-2.421-0.042c-39.786,0-72.041,32.254-72.041,72.042 c0,16.46,5.521,31.631,14.813,43.764c1.628,2.126,3.372,4.158,5.222,6.087c5.406,1.296,11.048,1.981,16.851,1.981 C104.631,153.917,136.886,121.663,136.886,81.877z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    fill: "#FFFFFF",
    d: "M151.766,70.606c0,15.971-23.176,28.917-51.767,28.917 c-28.589,0-51.766-12.947-51.766-28.917c0-15.971,23.177-37.669,51.766-37.669C128.59,32.937,151.766,54.635,151.766,70.606z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoloGrey);
export default __webpack_public_path__ + "static/media/soloGrey.5b1bbcf08a0c5e09689642991cafcd3b.svg";
export { ForwardRef as ReactComponent };